<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="3" class="my-1">

            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>

          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
              @update="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></date-range-picker>
          </b-col>
          <b-col md="2">
            <label>Shipping Line</label>
            <model-list-select :list="$store.getters['common/getAllShippingLineList']" v-model="Filter.slineFilter"
              option-value="shippingId" option-text="shippingLine" placeholder="Select Shipping Line"
              @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
          </b-col>
          <b-col md="2">
            <label>Contract No</label>
            <model-list-select class="ml-1" :list="$store.getters['common/getAllContractList']" id="fk_contract_id"
              v-model="Filter.fk_contract_id" option-value="value" option-text="label"
              placeholder="Select Contract NUMBER"
              @input="getContractNoBasedVessel(Filter.fk_contract_id); getBrfAnalysisList('Normal', '0', '0', '1', '1')" />
            <!-- <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Contract No Filter"
              id="contract_no" name="contract_no" autocomplete="off" v-model="Filter.contract_no"
              @input="getContractNoBasedVessel(Filter.contract_no); getBrfAnalysisList('Normal', '0', '0', '1', '1')"></b-form-input> -->
          </b-col>

          <b-col md="2">
            <label for="blType">Vessel Name :</label>
            <model-list-select class="ml-1" :list="$store.getters['common/getAllContractBasedVesselList']"
              id="vessel_name" v-model="Filter.fk_ccbm_id" option-value="value" option-text="label"
              placeholder="Select Vessel Name" @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')" />
          </b-col>

          <b-col md="2">
            <label>Common Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter" id="serach_txt"
              name="serach_txt" autocomplete="off" v-model="Filter.serach_txt"
              @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></b-form-input>
          </b-col>


          <b-col md="2">
            <b-button class="pull-right ml-1 mt-5" :variant="Filter.DateTypeFilter ||
              Filter.JobNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.paymentTypeFilter ||
              Filter.SOBFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.serach_txt ||
              Filter.contract_no ||
              Filter.fk_contract_id ||
              Filter.fk_ccbm_id ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.paymentTypeFilter ||
                  Filter.SOBFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.serach_txt ||
                  Filter.contract_no ||
                  Filter.fk_contract_id ||
                  Filter.fk_ccbm_id ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-5" v-if="getAnalysisList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getAnalysisList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

          </b-col>

          <b-col cols="9">
            <div>
              <b-pagination limit="50" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="3">
            <h5>
              <small v-if="isLoading == false">{{ getAnalysisList.length }} Entries</small>
            </h5>
          </b-col>

          <b-col cols="12">
            <div v-if="visible">
              <b-card>
                <b-collapse v-model="visible" id="collapse-2">
                  <b-row>
                    <b-col md="3">
                      <label>Date Type</label>
                      <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
                        option-text="text" placeholder="Select Date Type"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Date</label>
                      <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange"
                        :startDate="startDate" :endDate="endDate" :locale-data="locale"
                        :disabled="Filter.DFlag ? true : false"
                        @update="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></date-range-picker>
                    </b-col>
                    <b-col md="3">
                      <label>Job NO Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job NO Filter"
                        id="JobNoFilter" name="JobNoFilter" autocomplete="off" v-model="Filter.JobNoFilter"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label>Transport Type</label>
                      <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter"
                        option-value="value" option-text="value" placeholder="Select Transport Type"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>Shipment Type</label>
                      <model-list-select :list="shipmentTypeList" v-model="Filter.ShipemntTypeFilter"
                        option-value="value" option-text="value" placeholder="Select Shipment Type"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>Shipping Line</label>
                      <model-list-select :list="$store.getters['commonDropdownMaster/getAllPendingSlineInvDDList']"
                        v-model="Filter.slineFilter" option-value="value" option-text="label"
                        placeholder="Select Shipping Line" @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')" />

                    </b-col>
                    <b-col md="3">
                      <label>Client</label>
                      <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                        v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                        placeholder="Select Client Name"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Branch</label>
                      <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                        v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All" @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>

                    <b-col md="3">
                      <label>POR</label>
                      <model-list-select :list="$store.getters['common/getAllPORList']" id="PORFilter"
                        v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All" @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>POL</label>
                      <model-list-select :list="$store.getters['common/getAllPOLList']" id="POLFilter"
                        v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All" @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>POD</label>
                      <model-list-select :list="$store.getters['common/getAllPODList']" id="PODFilter"
                        v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All" @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>FPOD</label>
                      <model-list-select :list="$store.getters['common/getAllLocationDetailsFinalList']" id="FPODFilter"
                        v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation"
                        placeholder="All" @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></model-list-select>
                    </b-col>
                    <b-col md="3">
                      <label>Contract No Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Contract No Filter"
                        id="contract_no" name="contract_no" autocomplete="off" v-model="Filter.contract_no"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></b-form-input>
                    </b-col>

                    <b-col md="3">
                      <label>Common Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                        id="serach_txt" name="serach_txt" autocomplete="off" v-model="Filter.serach_txt"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')"></b-form-input>
                    </b-col>

                    <b-col md="3">
                      <label>
                        <b> Created User </b>
                      </label>
                      <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                        @input="getBrfAnalysisList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                        option-value="userId" option-text="employeeName"
                        placeholder="Select Created User"></model-list-select>
                    </b-col>

                    <b-col md="12" class="mt-2">
                      <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                        variant="outline-danger">Reset</b-button>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </div>
          </b-col>


          <b-col cols="12" class="table-responsive tableMain ">

            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th colspan="11" class="text-right">
                    <h4>Total BRF Containers:{{ getTotalContainersTEUS.totBRFContainerCount }}</h4>
                    <h4>Total JOB Containers:{{ getTotalContainersTEUS.usedtotalContainers }}</h4>
                  </th>
                  <th>
                    <h4> Total BRF TEUS:{{ getTotalContainersTEUS.totBRFTeusCount }}</h4>
                    <h4> Total JOB TEUS:{{ getTotalContainersTEUS.usedtotalTEUS }}</h4>
                  </th>
                </tr>
              </thead>
            </table>

            <b-table show-empty stacked="md" responsive :items="getAnalysisList" :fields="AnalysisFields"
              primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
              class="position-relative no-wrap">
              <template slot="checkbox" slot-scope="row0">
                <div class="d-flex align-items-center gap-2">
                  <b-button @click="row0.toggleDetails" class="mr-2" size="sm" style="font-size: 0.675rem"
                    variant="outline-info">
                    <md-icon>{{ row0.detailsShowing ? "expand_less" : "expand_more" }}</md-icon>
                    {{ row0.detailsShowing ? "Hide More" : "Show More" }}
                    Details
                  </b-button>

                </div>
              </template>
              <template slot="SN" slot-scope="row0">
                <div class="d-flex align-items-center gap-2">
                  <b-button @click="row0.toggleDetails" class="mr-2" size="sm" style="font-size: 0.675rem"
                    variant="outline-info">
                    <md-icon>{{ row0.detailsShowing ? "expand_less" : "expand_more" }}</md-icon>
                    {{ row0.detailsShowing ? "Hide More" : "Show More" }}
                    Details
                  </b-button>

                </div>
                <span>
                  {{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}
                </span>
              </template>
              <template slot="JobNO" slot-scope="row0">
                <b-badge v-for="(job, index) in (row0.item.JobNO ? row0.item.JobNO.split(',') : [])" :key="index"
                  style="margin-left: 5px;" variant="success">
                  {{ job.trim() }}
                </b-badge>
              </template>

              <template slot="JobSOB" slot-scope="row0" style="width: 200%;">
                <b-badge v-for="(sob, index) in (row0.item.JobSOB ? row0.item.JobSOB.split(',') : [])" :key="index"
                  style="margin-left: 5px;" variant="success">
                  {{ sob.trim() }}
                </b-badge>
              </template>

              <template slot="BRFNo" slot-scope="row0" style="width: 200%;">
                <b-badge v-for="(brf, index) in (row0.item.BRFNo ? row0.item.BRFNo.split(',') : [])" :key="index"
                  style="margin-left: 5px;" variant="warning">
                  {{ brf.trim() }}
                </b-badge>
              </template>


              <!-- Expandable Row for Additional Details -->

              <template slot="row-details" slot-scope="row4">
                <b-card style="background: whiteSmoke">
                  <b-row>
                    <b-col md="3" class="mb-2" v-if="row4.item.contractNo">
                      <span><b>Contract No:</b> {{ row4.item.contractNo }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.ContractFrom">
                      <span><b>Contract From :</b> {{ row4.item.ContractFrom }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.ContractTo">
                      <span><b>Contract To :</b> {{ row4.item.ContractTo }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.vessel">
                      <span><b>Vessel :</b> {{ row4.item.vessel }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.voyage">
                      <span><b>Voyage :</b> {{ row4.item.voyage }}<br /></span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.ContractCreatedAt"><span><b>Contract Created At :</b> {{
                      row4.item.ContractCreatedAt }}<br /></span></b-col>

                    <b-col md="3" class="mb-2" v-if="row4.item.Sline"><span><b>Sline :</b>
                        {{ row4.item.Sline }}<br /></span></b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.POR"><span><b>POR :</b>{{
                      row4.item.POR }}<br /></span></b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.POL">
                      <span><b>POL:</b> {{ row4.item.POL }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.POD">
                      <span><b>POD:</b> {{ row4.item.POD }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.FPOD">
                      <span><b>FPOD:</b> {{ row4.item.FPOD }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.containerType">
                      <span><b>Container Type:</b> {{ row4.item.containerType }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.totalContainers">
                      <span><b>Container Count:</b> {{ row4.item.totalContainers }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.totalTEUS">
                      <span><b>Tues Count:</b> {{ row4.item.totalTEUS }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.usedContainers">
                      <span><b>Used Container Count:</b> {{ row4.item.usedContainers }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.totalTEUS">
                      <span><b>Used Tues Count:</b> {{ row4.item.totalTEUS }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BookingVessel">
                      <span><b>Booking Vessel Name:</b> {{ row4.item.BookingVessel }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BookingVoyage">
                      <span><b>Booking Vessel Voyage No:</b> {{ row4.item.BookingVoyage }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BuyRate">
                      <span><b>Buy Rate:</b> {{ row4.item.BuyRate }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.SellRate">
                      <span><b>Selling Rate:</b> {{ row4.item.SellRate }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.Currency">
                      <span><b>Currency:</b> {{ row4.item.Currency }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.Country">
                      <span><b>Country:</b> {{ row4.item.Country }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BookingSOB">
                      <span><b>Booking SOB/ETD:</b> {{ row4.item.BookingSOB }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.JobSOB">
                      <span><b>JOB SOB/ETD:</b> {{ row4.item.JobSOB }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.ContinerRemark">
                      <span><b>Container Remark:</b> {{ row4.item.ContinerRemark }}</span>
                    </b-col>

                    <b-col md="3" class="mb-2" v-if="row4.item.JobNo">
                      <span><b>Job No:</b> {{ row4.item.JobNo }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.JobSOB">
                      <span><b>Job SOB:</b> {{ row4.item.JobSOB }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.JobVessel">
                      <span><b>Job Vessel:</b> {{ row4.item.JobVessel }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.JobVoyage">
                      <span><b>Job Voyage:</b> {{ row4.item.JobVoyage }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.MBL">
                      <span><b>MBL:</b> {{ row4.item.MBL }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.HBL">
                      <span><b>HBL:</b> {{ row4.item.HBL }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.EnqNo">
                      <span><b>Enq No:</b> {{ row4.item.EnqNo }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BRFNo">
                      <span><b>BRF No:</b> {{ row4.item.BRFNo }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BRFEnqNo">
                      <span><b>BRF Enq No:</b> {{ row4.item.BRFEnqNo }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BRFCreatedBy">
                      <span><b>BRF Created By:</b> {{ row4.item.BRFCreatedBy }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.BRFCreatedDate">
                      <span><b>BRF Created At:</b> {{ row4.item.BRFCreatedDate }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.booking_no">
                      <span><b>Booking No:</b> {{ row4.item.booking_no }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.bookingType">
                      <span><b>Booking Type:</b> {{ row4.item.bookingType }}</span>
                    </b-col>
                    <b-col md="3" class="mb-2" v-if="row4.item.validity_doc">
                      <span v-if="row4.item.validity_doc.split(',')">
                        <b v-if="row4.item.validity_doc.split(',').length > 0">
                          <span v-for="(item_doc, index_doc) in sanitizedArray(row4.item.validity_doc.split(','))"
                            :key="index_doc">
                            <b-button style="margin-left: 2px; font-size: 0.675rem"
                              v-if="item_doc != '' && row4.item.BookingStatus == '1'"
                              @click="PrintValidity_Doc(item_doc)" size="sm" variant="warning"
                              class="mb-1">PDF</b-button>

                            <br />
                          </span>
                        </b>
                      </span>
                    </b-col>
                  </b-row>
                </b-card>
              </template>



            </b-table>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th colspan="11" class="text-right">
                    <h4>Total BRF Containers:{{ getTotalContainersTEUS.totBRFContainerCount }}</h4>
                    <h4>Total JOB Containers:{{ getTotalContainersTEUS.usedtotalContainers }}</h4>
                  </th>
                  <th>
                    <h4> Total BRF TEUS:{{ getTotalContainersTEUS.totBRFTeusCount }}</h4>
                    <h4> Total JOB TEUS:{{ getTotalContainersTEUS.usedtotalTEUS }}</h4>
                  </th>
                </tr>
              </thead>
            </table>
          </b-col>
          <b-col md="12">
            <b-pagination limit="50" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({ itemCode: "LocationDetailsFinalList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch("common/setAllContractList", {
        filter: "ContractList",
        active: "all",
        isAll: 1,
        cb_is_active: 1,
        cb_is_deleted: 0,
        isSelectedColumn: 1,
      }),
      this.$store.dispatch("common/setAllContractBasedVesselList", {
        filter: "ContractVesselList",
        active: "all",
        isAll: 0,
        ccbm_is_active: 1,
        ccbm_is_deleted: 0,
        isSelectedColumn: 0,
        // isSelectedColumn: 1,
        fk_cb_id: 0,
        is_withoutcb: 1,
      }),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getBrfAnalysisList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getAnalysisList: [],
      totalData: 0,

      validate: true,

      // Date format for datepickers

      dateFormat: { year: "numeric", month: "short", day: "numeric" },

      AnalysisFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
          tdClass: 'text-nowrap'
        },

        {
          key: "Branch",
          mainkey: "Branch",
          label: "Branch",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "vessel",
          mainkey: "vessel",
          label: "Vessel",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "voyage",
          mainkey: "voyage",
          label: "Voyage",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "containerType",
          mainkey: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "BookingSOB",
          mainkey: "BookingSOB",
          label: "Booking SOB",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "JobSOB",
          mainkey: "JobSOB",
          label: "Job SOB",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          // tdClass: 'text-nowrap'
        },
        {
          key: "shipperName",
          mainkey: "shipperName",
          label: "Shipper",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "booking_no",
          mainkey: "booking_no",
          label: "Booking No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "contractNo",
          mainkey: "contractNo",
          label: "Contract No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        // {
        //   key: "totalTEUS",
        //   mainkey: "totalTEUS",
        //   label: " BRF EQUIP. (Teus)",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "totalContainers",
        //   mainkey: "totalContainers",
        //   label: "BRF CONTAINER",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        {
          key: "totBRFTeusCount",
          mainkey: "totBRFTeusCount",
          label: " BRF EQUIP. (Teus)",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "totBRFContainerCount",
          mainkey: "totBRFContainerCount",
          label: "BRF CONTAINER",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "usedtotalTEUS",
          mainkey: "usedtotalTEUS",
          label: "Job EQUIP. (Teus)",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "usedContainers",
          mainkey: "usedContainers",
          label: "Job CONTAINER",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "POD",
          mainkey: "POD",
          label: "POD",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "BuyRate",
          mainkey: "BuyRate",
          label: "Buy Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "SellRate",
          mainkey: "SellRate",
          label: "Sell Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "usedBuyRate",
          mainkey: "usedBuyRate",
          label: "Total Buy Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "usedSellRate",
          mainkey: "usedSellRate",
          label: "Total Sell Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "usedProfitLoss",
          mainkey: "usedProfitLoss",
          label: "Profit/Loss",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          // tdClass: 'text-nowrap'
        },
        {
          // key: "usedBRFNo",
          // mainkey: "usedBRFNo",
          key: "BRFNo",
          mainkey: "BRFNo",
          label: "BRF No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          // tdClass: 'text-nowrap'
        },
        {
          key: "action",
          mainkey: "action",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,


      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      paymentTypeList: [
        {
          text: "FF Export",
          value: "FF",
        },
        {
          text: "CC Export",
          value: "CC",
        },
        {
          text: "Import",
          value: "IMP",
        },
      ],
      transportTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      dateTypeList: [
        {
          text: "Job",
          value: "1",
        },
        {
          text: "Payment Request Date",
          value: "2",
        },
      ],
      Filter: {
        DateTypeFilter: "2",
        JobNoFilter: "",
        fk_contract_id: "",
        fk_ccbm_id: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        paymentTypeFilter: "",
        SOBFilter: "3",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        serach_txt: "",
        contract_no: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      ExpImpType: "0",
      isSubmited: false,
      isFileLoading: false,

      LabelType: "shortlist",
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {
    getTotalContainersTEUS() {
      return this.getAnalysisList.reduce(
        (acc, curr) => {
          acc.usedtotalTEUS += curr.usedtotalTEUS || 0
          acc.usedtotalContainers += curr.usedtotalContainers || 0
          acc.totBRFContainerCount += curr.totBRFContainerCount || 0
          acc.totBRFTeusCount += curr.totBRFTeusCount || 0
          return acc
        },
        { usedtotalTEUS: 0, usedtotalContainers: 0, totBRFContainerCount: 0, totBRFTeusCount: 0 }
      )
    },
    // // If number of selected rows = total rows in getAnalysisList
    // allSelected() {
    //   return this.selectedCheckBoxRows.length === this.getAnalysisList.length;
    // }
  },
  watch: {},
  methods: {
    getContractNoBasedVessel(fk_contract_idFilter) {
      this.$store.dispatch("common/setAllContractBasedVesselList", {
        filter: "ContractVesselList",
        active: "all",
        isAll: 0,
        ccbm_is_active: 1,
        ccbm_is_deleted: 0,
        isSelectedColumn: 0,
        // isSelectedColumn: 1,
        fk_cb_id: fk_contract_idFilter,
        is_withoutcb: 1,
      });
    },
    sanitizedArray(validity_doc) {
      // Use the map method to replace "\n" with []
      const replacedArray = validity_doc.map((item) => {
        if (item === "\n") {
          return [];
        } else {
          return item;
        }
      });

      // Flatten the replacedArray and remove empty arrays
      const flattenedArray = replacedArray.reduce((acc, curr) => {
        if (Array.isArray(curr) && curr.length === 0) {
          return acc;
        }
        return acc.concat(curr);
      }, []);

      return flattenedArray;
    },
    PrintValidity_Doc(validity_doc) {
      this.openSignedDocument(`ASSIGNMENT_UPLOADS/Console_Booking_Doc/${validity_doc}`);
    },
    clearFilter() {
      this.Filter = {
        DateTypeFilter: "2",
        JobNoFilter: "",
        fk_contract_id: "",
        fk_ccbm_id: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        paymentTypeFilter: "",
        SOBFilter: "3",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        serach_txt: "",
        contract_no: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getBrfAnalysisList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      // Subtract 1 day from today to get the previous day
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      // Format yesterday's date (DD/MM/YYYY)
      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; // 11/02/2025

      // Format today's date (DD/MM/YYYY)
      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; // 12/02/2025

      // Set startDate and endDate
      this.startDate = startDate;
      // this.Filter.dateRange = {
      //   startDate: startDate, // 11/02/2025
      //   endDate: endDate,     // 12/02/2025
      // };
    },

    getBrfAnalysisList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getAnalysisList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        serach_txt: this.Filter.serach_txt,
        generateExcel: this.generateExcel,
        ExpImpType: this.ExpImpType,
        is_sortlisted: 1,
        is_finalized: 0,
        is_finalizedStatus: 0,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getBookingRespVesselJobProfitLoss(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-BRF-Analysis-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getBrfAnalysisList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalCounts;
                this.getAnalysisList = data.assignmentCountMapArr;
                this.pagination.totalRows = data.meta.totalCounts;
                this.pagination.currentPage = data.meta.currentPage;
                this.pagination.perPage = data.meta.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAnalysisList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getBrfAnalysisList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getBrfAnalysisList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBrfAnalysisList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBrfAnalysisList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>
<style scoped>
.no-wrap td,
.no-wrap th {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// BRFVesselList.vue?652c21f9